import { Helmet } from 'react-helmet'
import getStoryblokImageDimensions from 'utils/getStoryblokImageDimensions'

const ImgStoryblok = ({
  src,
  alt,
  width,
  height,
  dataTest,
  pictureProps = {},
  preload = false,
  ...rest
}) => {
  const fallBackImage = src?.replace(
    'https://a.storyblok.com',
    'https://assets.renegocie.gruporecovery.com'
  )

  const isSvg = src?.includes('.svg')
  const webpImage = `${fallBackImage}/m/`

  if (!isSvg) {
    width = width || getStoryblokImageDimensions(src).width
    height = height || getStoryblokImageDimensions(src).height
  }

  return (
    <picture {...pictureProps} data-test={dataTest}>
      {preload && (
        <Helmet>
          <link
            rel="preload"
            href={webpImage}
            as="image"
            type="image/webp"
            crossOrigin
          />
        </Helmet>
      )}
      {!isSvg && (
        <source
          {...rest}
          srcSet={webpImage}
          type="image/webp"
          width={width}
          height={height}
        />
      )}
      <img
        {...rest}
        src={fallBackImage}
        alt={alt}
        width={width}
        height={height}
      />
    </picture>
  )
}

export default ImgStoryblok
